
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import SocialLoginButtons from "./SocialLoginButtons";

interface SignupFormProps {
  onSubmit: (e: React.FormEvent) => Promise<void>;
  onGoogleSignIn: () => Promise<void>;
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  isAgree: boolean;
  setIsAgree: (agree: boolean) => void;
  isLoading: boolean;
}

const SignupForm = ({
  onSubmit,
  onGoogleSignIn,
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
  isAgree,
  setIsAgree,
  isLoading
}: SignupFormProps) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">Full Name</Label>
        <Input 
          id="name" 
          placeholder="John Doe" 
          required 
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input 
          id="email" 
          type="email" 
          placeholder="name@example.com" 
          required 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="password">Password</Label>
        <Input 
          id="password" 
          type="password" 
          required 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <p className="text-xs text-gray-500">
          Password must be at least 8 characters long and include at least one number and one special character.
        </p>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="terms" 
          checked={isAgree}
          onCheckedChange={(checked) => setIsAgree(checked as boolean)}
        />
        <label
          htmlFor="terms"
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          I agree to the{" "}
          <Link to="/terms" className="text-ai-indigo hover:text-ai-purple">
            terms of service
          </Link>{" "}
          and{" "}
          <Link to="/privacy" className="text-ai-indigo hover:text-ai-purple">
            privacy policy
          </Link>
        </label>
      </div>
      
      <Button 
        type="submit" 
        className="w-full bg-gradient-to-r from-ai-indigo to-ai-purple"
        disabled={isLoading || !isAgree}
      >
        {isLoading ? "Creating account..." : "Create account"}
      </Button>

      <div className="relative my-4">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">Or continue with</span>
        </div>
      </div>
      
      <SocialLoginButtons onGoogleSignIn={onGoogleSignIn} isLoading={isLoading} />
    </form>
  );
};

export default SignupForm;
